"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OPTIONS_TYPE = exports.OPTION_GROUP_TYPE = exports.OPTION_TYPE = exports.VALUE_TYPE = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var VALUE_TYPE = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]);

exports.VALUE_TYPE = VALUE_TYPE;

var OPTION_TYPE = _propTypes.default.shape({
  key: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  label: _propTypes.default.string.isRequired,
  value: VALUE_TYPE.isRequired,
  disabled: _propTypes.default.bool,
  data: _propTypes.default.object,
  style: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.shape({
    option: _propTypes.default.object,
    value: _propTypes.default.object
  })]),
  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    option: _propTypes.default.string,
    value: _propTypes.default.string
  })])
});

exports.OPTION_TYPE = OPTION_TYPE;

var OPTION_GROUP_TYPE = _propTypes.default.shape({
  label: _propTypes.default.string.isRequired,
  options: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.arrayOf(OPTION_TYPE)]).isRequired
});

exports.OPTION_GROUP_TYPE = OPTION_GROUP_TYPE;

var OPTIONS_TYPE = _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.arrayOf(OPTION_GROUP_TYPE), _propTypes.default.arrayOf(OPTION_TYPE)]);

exports.OPTIONS_TYPE = OPTIONS_TYPE;